import { EyeOutlined } from '@ant-design/icons';
import { getGetBackDocumentaleFascicoliIdDocumentiIdAllegatiIdDownloadQueryOptions } from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import {
  useAuthDownload,
  useHasDocumentsInlineViewer,
} from '@framework/common-web';
import { Button, message } from 'antd';
import React from 'react';

export interface IDocumentalAttachmentDownloadButtonProps {
  token: string | null | undefined;
  dossierId: string | null | undefined;
  documentId: string | null | undefined;
  attachmentId: string | null | undefined;
  filename: string;
}

/**
 * Pulsante "Scarica" per il download dei documenti nel fasicolo dal documentale.
 * (Tab "Fascicolo" del procedimento)
 */
export function DocumentalAttachmentDownloadButton(
  props: IDocumentalAttachmentDownloadButtonProps,
) {
  const { token, documentId, dossierId, filename, attachmentId } = props;
  const hasInlineViewer = useHasDocumentsInlineViewer();

  const { download, isFetching } = useAuthDownload(
    getGetBackDocumentaleFascicoliIdDocumentiIdAllegatiIdDownloadQueryOptions,
    [dossierId ?? '', documentId ?? '<N/A>', attachmentId ?? '<N/A>'],
    {
      filename,
      onError: (e: any) => {
        message.error(getNetworkErrorMessage(e, 'Si è verificato un problema durante l\'apertura del file')); // prettier-ignore
      },
      // Imposto il token di autorizzazione per il download
      headers: { 'Authorization-Documenti': token ?? '<N/A>' },
      openInNewWindow: true,
      showInlineViewer: hasInlineViewer,
    },
  );

  return (
    <Button
      icon={<EyeOutlined />}
      type="link"
      loading={isFetching}
      onClick={() => {
        if (!token || !dossierId || !documentId) {
          console.error('Impossibile scaricare l\'allegato. Token o ID non disponibili.', { props }); // prettier-ignore
          message.error('Impossibile scaricare l\'allegato. Token o ID non disponibili.'); // prettier-ignore
          return;
        }

        download();
      }}
    >
      Visualizza
    </Button>
  );
}
